import { css } from '@emotion/css'

const styles = {
  phoneNumberWrapper: css({
    position: 'relative',
    borderRadius: '3px',
    border: '1px solid #E4EBEF',
    height: '40px',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    maxWidth: '700px',
  }),
  phoneNumberField: css({
    color: '#7C7C80',
    fontSize: '16px',
    lineHeight: 1.2,
    padding: '6px 12px',
    appearance: 'none',
    border: 'none',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    borderRadius: '3px',
  }),
}

export default styles
